const config = require('../config'); const apiConfig = require('../api-config');
const apiFactory = require('../resources/payment.js/api-factory');
const serviceFactory = require('../resources/payment.js/service-factory');

function addRoutes({ requestHandler } = {}) {
  const api = apiFactory({
    requestHandler,
    baseUrl: `${config.baseUrl}/payment/${apiConfig.apiversion}/`,
    authToken: config.authToken,
  });

  const service = serviceFactory({ api });

  const p = '[{keys:metaData}].';
  return app => app
      
      .match((`${p}payment.validateBeneficiary[{keys:beneficiaryDetails}][{keys:guidStr}]`), requests =>
        Promise.all(requests.map(({ req, res }) =>
        service.validateBeneficiary(req.params.beneficiaryDetails, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))

      .match(`${p}payment.getBeneficiaryList[{keys:inputParam}][{keys:guidStr}]`, requests => 
        Promise.all(requests.map(({ req, res }) =>
        service.getBeneficiaryList(req.params.inputParam, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))

      .match(`${p}payment.getBeneficiaryListAll[{keys:inputParam}][{keys:guidStr}]`, requests => 
        Promise.all(requests.map(({ req, res }) =>
        service.getBeneficiaryListAll(req.params.inputParam, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))

      .match(`${p}payment.addNewBeneficiary[{keys:inputParam}][{keys:guidStr}]`, requests => 
        Promise.all(requests.map(({ req, res }) =>
        service.addBeneficiaryDetails(req.params.inputParam, req.params.metaData)
          .then(xs => res.value(xs))
          .catch(res.error)
      )))
      
      .match(`${p}payment.paymentsBenValidate[{keys:inputParam}][{keys:guidStr}]`, requests => Promise.all(
        requests.map(({req, res}) => 
          service.paymentsBenValidate(req.params)
            .then(response => res.value(response))
            .catch(res.error)
        )))

      .match((`${p}payment.beneficiariesNamesPatch[{keys:inputParam}][{keys:guidStr}]`), requests => Promise.all(
        requests.map(({ req, res }) =>
          service.beneficiariesNamesPatch(req.params)
            .then(response => res.value(response))
            .catch(res.error)
      ) ) )
}

module.exports = addRoutes;
